module.exports = __webpack_public_path__ + "img/car.388161a7.png";